import topics from './support/topics'

const support =
{
    // dependencies
    topics
};

export default support ;
